export default "/images/codan.webp?5c67877ade94d96945cf40f5ac6937b5";